import { BaseEntity } from "@app/models/rest/base-entity";
import {
  Resource_BasicProjection,
  ResourceModel
} from "@app/models/rest/resource";
import { AvailabilityCode } from "@app/models/rest/availability-code";
import { LocationModel } from "@app/models/rest/location";
import {
  HateoasProjection,
  HateoasResource,
  ProjectionRel
} from "@lagoshny/ngx-hateoas-client";
import { TimesheetCode } from "@app/models/rest/timesheet-code";

@HateoasResource("resourceAvailabilities")
export class ResourceAvailability extends BaseEntity {
  resource: ResourceModel;
  start: Date;
  end: Date;
  availabilityCode: AvailabilityCode;
  description: string;
  autoGenerated: boolean;
  cyclicalPriorityReservationDuration: number;
  cyclicalPriorityReservationPercent: number;
  normalPriorityReservationDuration: number;
  normalPriorityReservationPercent: number;
  highPriorityReservationDuration: number;
  highPriorityReservationPercent: number;
  emergencyPriorityReservationDuration: number;
  emergencyPriorityReservationPercent: number;
  location: LocationModel;
  travelTimesheetCode: TimesheetCode;
  workingTimesheetCode: TimesheetCode;
  overrideTimesheetCode: TimesheetCode;
  overrideTime: Date;
}

@HateoasProjection(ResourceAvailability, "detail")
export class ResourceAvailability_DetailProjection extends BaseEntity {
  @ProjectionRel(ResourceModel)
  resource: Resource_BasicProjection;
  start: Date;
  end: Date;
  availabilityCode: AvailabilityCode;
  description: string;
  autoGenerated: boolean;
  cyclicalPriorityReservationDuration: number;
  cyclicalPriorityReservationPercent: number;
  normalPriorityReservationDuration: number;
  normalPriorityReservationPercent: number;
  highPriorityReservationDuration: number;
  highPriorityReservationPercent: number;
  emergencyPriorityReservationDuration: number;
  emergencyPriorityReservationPercent: number;

  location: LocationModel;
}
